module.exports = __webpack_public_path__ + "img/to_rechargepray_jp.9206cc6c.png";